<div class="modal-header">
  <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close">
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Two-Factor Authentication</h4>
</div>
<div class="modal-body" style="overflow: visible;">
  <div class="content" *ngIf="!isTokenCreated && !phone_info.is_phone_number_verified">
    <h2>Set up two-factor authentication.</h2>

    <div class="text">
      Enter your mobile phone number to receive a 6-digit verification code to
      enable two-factor authentication.
    </div>

    <div *ngIf="!isTokenCreated" class="wrapper-phone">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="PhoneNumber">Phone Number</label>
            <div class="input-group">
              <ngx-intl-tel-input [(ngModel)]="phoneInput" [preferredCountries]="[
                  CountryISO.UnitedStates,
                  CountryISO.Canada
                ]" [enableAutoCountrySelect]="false" [enablePlaceholder]="false" [searchCountryFlag]="true"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name
                ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.UnitedStates"
                [phoneValidation]="true"></ngx-intl-tel-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="btn btn-primary btn-lg btn-block" (click)="generateSmsToken()">
        Send Verification Code
      </button>
    </div>
  </div>

  <div class="content" *ngIf="isTokenCreated">
    <h2>
      Code sent to {{ mockNumber != "" ? mockNumber : data?.phone_number }}

      <button class="btn btn-link" (click)="changeNumber()">
        Change number
      </button>
    </h2>

    <div class="text">
      Enter the 6-digit verification code to enable two-factor authentication
      for your account.
    </div>

    <div class="wrapper-phone">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="VerificationCode" style="margin-bottom: 12px">Verification Code</label>

            <code-input class="code" [codeLength]="6" (codeChanged)="onCodeChanged($event)"
              (codeCompleted)="onCodeCompleted($event)">
            </code-input>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="btn btn-primary btn-lg btn-block" (click)="verifySmsCode()"
        [disabled]="verificationCode?.length < 6">
        Confirm verification code
      </button>

      <button class="btn btn-lg btn-block btn-link" (click)="verifySmsCode()" [disabled]="">
        Resend
      </button>
    </div>
  </div>
</div>

<div class="modal-body" *ngIf="phone_info.is_phone_number_verified">
  <button class="btn btn-primary btn-lg" (click)="remove2FA()">
    Remove 2FA
  </button>
</div>